module.exports = __webpack_public_path__ + "static/img/3k.7051e9e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/3k.jpg
// module id = cRnI
// module chunks = 0